export const assetPath =
  document
    .querySelector('#virtual-photo-booth')
    ?.dataset?.assetPath?.replace('.html', '/') || '';
